<app-nav titulo="Notificaciones" descripcion="Estas son todas las notificaciones recibidas a su cuenta hasta la fecha.">
    <div class="notifications">
        <app-data-table
            [rows]="notifications"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            [menuButtons]="menuButtons"
            (updateRows)="updateNotifications($event)"
        ></app-data-table>
    </div>
</app-nav>
